module.exports = __webpack_public_path__ + "static/img/video-pass.55a1b61a.png";